import React from 'react'

import Error404 from 'components/Error404/Error404'
import PublicLayout from 'components/PublicLayout/PublicLayout'

const ErrorPage404: React.FC = () => (
  <PublicLayout>
    <Error404 />
  </PublicLayout>
)

export default ErrorPage404
